export default class ContactBar {
  private wrapper: HTMLElement;
  private trigger: HTMLElement;
  private closeBtn: HTMLElement;
  private active = false;

  bindings() {
    this.trigger?.addEventListener('click', () => this.toggleState());
    this.closeBtn?.addEventListener('click', () => this.toggleState());
  }

  toggleState() {
    this.wrapper.classList.toggle('is-active', this.active = !this.active);
  }

  cache() {
    this.wrapper =  document.querySelector<HTMLElement>(
      '.m-contact-bar'
    )!;

    this.trigger = document.querySelector<HTMLElement>(
      '.m-contact-bar__trigger'
    )!;

    this.closeBtn = document.querySelector<HTMLElement>(
      '.m-contact-bar__menu__close'
    )!;
  }

  init() {
    this.cache();
    this.bindings();
  }
}
